import { analyticsActionTypes } from "../constants";

const initialState = {
  loading: false,
  data: [],
  error: ""
};

export const analytics = (state = initialState, action) => {
  switch (action.type) {
    case analyticsActionTypes.ANALYTICS_LOADING:
      return {
        ...state,
        loading: true,
        error: ""
      };
    case analyticsActionTypes.ANALYTICS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: ""
      };
    case analyticsActionTypes.ANALYTICS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case analyticsActionTypes.ANALYTICS_RESET:
      return {
        ...state,
        main: [],
      };
    default:
      return state;
  }
};
